const withSupervisorUsers = supervisorUsers => prevTemplate => ({
    ...prevTemplate,
    supervisorUsers,
});

export default withSupervisorUsers;
